import * as z from "zod";
import { getMarketSeries, MAX_MARKET_SERIES } from "../tools/definitions/get-market-series";
import { upperCased } from "./upper-cased";

/** Without `from`, a chart shows this many years up to `to`, or up to today. */
export const FRED_CHART_TRAILING_YEARS = 10;

/**
 * The `get_market_series` call the agent just made, so the chart plots what it read.
 * Extending the tool's input keeps its fields, strictness and `from <= to` check; `safeExtend` is
 * what lets the upper-casing `seriesCodes` replace the tool's while keeping that check.
 */
export const fredChartSchema = getMarketSeries.input.safeExtend({
	source: z.literal("fred"),
	seriesCodes: z
		.array(upperCased.pipe(getMarketSeries.input.shape.seriesCodes.element))
		.min(1)
		.refine(
			(seriesCodes) => new Set(seriesCodes).size <= MAX_MARKET_SERIES,
			`A FRED chart takes at most ${MAX_MARKET_SERIES} distinct series, as \`get_market_series\` does.`,
		),
	/** Columns suit discrete annual figures that need a zero baseline, as Market Analytics uses. */
	variant: z.enum(["line", "column"]).default("line"),
	title: z.string().optional(),
});

export type FredChart = z.infer<typeof fredChartSchema>;
